"use strict";
import moment from "moment";

export class DateHelper {
    constructor(date = new Date()) {
        this.dateOriginal = date;
        this.date = moment(date).utcOffset(0);

        this.date.__proto__.difference = this.difference;
        this.date.__proto__.toInt = this.toInt;
        this.date.__proto__.toUrl = this.toUrl;

        return this.date;
    }

    /**
     * @public
     * Get the difference by the setted date in ctrl
     * @param {Date} date Date
     * @param {String} format Compare by
     * @returns {Number} Difference
     */
    difference = (date, format = "months") => {
        return this.date.diff(moment(date).utcOffset(0), format);
    };

    /**
     * @public
     * Get the labels of the period
     * @param {String} type Type of period
     * @returns {Object} Labels
     */
    static labels(type = "previous") {
        const labels = {
            previous: {
                monthly: "Mês Anterior",
                quarterly: "Trimestre Anterior",
                semester: "Semestre Anterior",
                yearly: "Ano Anterior",
                other: "Outro Período"
            },
            next: {
                monthly: "Próximo Mês",
                quarterly: "Próximo Trimestre",
                semester: "Próximo Semestre",
                yearly: "Próximo Ano",
                other: "Outro Período"
            }
        };

        return labels[type];
    }

    /**
     * @public
     * Indentify the mutipliers by kind of period
     * @param {String} key Period
     * @returns {Object || Number} Multiplier or all object
     */
    static multipliers(key) {
        const multipliers = {
            monthly: 1,
            quarterly: 3,
            semester: 6,
            yearly: 12
        };

        return key ? multipliers[key] : multipliers;
    }

    /**
     * @public
     * Get the object of period labels
     * @returns {Object} Labels by quarters number
     */
    static quarters() {
        return {
            2: "1º Trimestre",
            5: "2º Trimestre",
            8: "3º Trimestre",
            11: "4º Trimestre"
        };
    }

    static semesters() {
        return {
            5: "1º Semestre",
            11: "2º Semestre"
        };
    }

    /**
     * @private
     * Retona o nome de um Quarterly de acordo com uma data
     * @param {Object} moment
     * @param {Boolean}
     *
     * @returns {String}
     */
    static nameQuarterly = (date, abrev = false) => {
        const quarterly = moment(date).add(1, "month").month();

        const quarterlys = DateHelper.quarters();

        const result = quarterlys[quarterly];
        if (abrev && result) return result.substring(0, 4);

        return result;
    };

    /**
     * @private
     * Retona o nome de um semestre de acordo com uma data
     * @param {Object} moment
     * @param {Boolean}
     *
     * @returns {String}
     */
    static nameSemester = (date, abrev = false) => {
        const semester = moment(date).add(1, "month").month();

        const semesters = DateHelper.semesters();

        const result = semesters[semester];
        if (abrev && result) return result.substring(0, 4);

        return result;
    };

    /**
     * @public
     * Identify the corret label format by kind of the period
     * @param {String} key Period
     * @param {Boolean} abrev If want a abreviate mode
     * @returns {String || Object} The correct format or all the object
     */
    static labelFormat(key, abrev, semester) {
        const periods = {
            monthly: `${abrev ? "MM/YY" : "MMMM [de] YYYY"}`,
            quarterly: `Q[º] ${abrev ? "[Tri.]/YY" : "[Trimestre de] YYYY"}`,
            semester: `${semester}[º] ${
                abrev ? "[Sem.]/YY" : "[Semestre de] YYYY"
            }`,
            yearly: "YYYY"
        };

        return key ? periods[key] : periods;
    }

    /**
     * @public
     * Format the date setted
     * @param {String} format Format to transform
     * @returns {String} Date formatted
     */
    toInt = (format) => {
        return parseInt(this.date.format(format));
    };

    /**
     * @public
     * Transform the date setted in format to use in URL
     * @returns {String} Date formatted
     */
    toUrl = () => {
        return this.date.format("YYYY-MM");
    };

    /**
     * @public
     * Create an array with the years to actual year
     * @param {Number} year Year to start
     * @param {Number} year Last year
     * @returns {Array} Array of years
     */
    static years = (year = 2010, end = new DateHelper().toInt("YYYY")) => {
        const years = [];

        for (year; year <= end; year++) {
            years.push(year);
        }
        return years;
    };

    /**
     * Get the current year
     * @returns {String} - Curernt year, ex: 2020
     */
    static currentYear = () => {
        return new DateHelper().year();
    };

    static endOfMonth(date) {
        if (!date) return null;
        return new Date(moment(date).utcOffset(0).endOf("month"));
    }
}
